import { ModalContext } from "app/app";
import axios from "axios";
import { FieldInput } from "components/fieldInput";
import { ViewContext } from "components/lib";
import { Form, Formik } from "formik";
import { Fragment, useContext, useState } from "react";
import { useParams } from "react-router-dom";
import * as Yup from "yup";
import Loader from "./images/loader.gif";
import styles from "./styles.module.scss";

export function NotificationModal(props) {
  const { id } = useParams();

  const context = useContext(ViewContext);
  const { modal, setModal } = useContext(ModalContext);

  const [loading, setLoading] = useState(false);

  const options = [
    {
      value: "missed_payment",
      label: "Missed Payment",
    },
    {
      value: "down_payment",
      label: "Down Payment",
    },
    {
      value: "underwriting",
      label: "Underwriting",
    },
    {
      value: "eld_camera",
      label: "ELD/camera",
    },
    {
      value: "mvr_loss_runs",
      label: "MVR/Loss Runs",
    },
    {
      value: "other",
      label: "Other",
    },
  ];

  const validationSchema = Yup.object().shape({
    alert: Yup.string().required("This field is required!"),
    notes: Yup.string().required("This field is required!"),
  });

  return (
    <Fragment>
      {modal.name === "notification_modal" && (
        <div className={styles.background}>
          <div className={styles.wrapper}>
            <div className={styles.insideWrapper}>
              <div className={styles.title}>
                {modal.mode === "edit" ? "Edit" : "Create"} Notification
              </div>
              <div className={styles.line} />
              <Formik
                validationSchema={validationSchema}
                initialValues={{
                  alert:
                    modal.data && modal.data.alert
                      ? options.find((op) => op.label === modal.data.alert)
                          .value
                      : options[0].value,
                  notes: modal.data && modal.data.notes ? modal.data.notes : "",
                }}
                onSubmit={async (values) => {
                  setLoading(true);

                  switch (modal.mode) {
                    case "create":
                      await axios
                        .post(`/api/notification`, {
                          alert: values.alert,
                          notes: values.notes,
                          policy_id: id,
                          company_id: modal.data.company_id,
                          account_id: modal.data.account_id,
                        })
                        .then(() => {
                          setLoading(false);

                          context.notification.show(
                            "Notification created!",
                            "success",
                            true,
                            "toast",
                            "check-circle"
                          );

                          modal.action();
                          setModal({});
                        })
                        .catch(() => {
                          setLoading(false);

                          context.notification.show(
                            "Notification failed!",
                            "error",
                            false,
                            "toast",
                            "x-circle"
                          );

                          setModal({});
                        });
                      break;

                    case "edit":
                      await axios
                        .patch(`/api/notification/${modal.data.id}`, {
                          alert: values.alert,
                          notes: values.notes,
                        })
                        .then(() => {
                          setLoading(false);

                          context.notification.show(
                            "Notification created!",
                            "success",
                            true,
                            "toast",
                            "check-circle"
                          );

                          modal.action();
                          setModal({});
                        })
                        .catch(() => {
                          setLoading(false);

                          context.notification.show(
                            "Notification failed!",
                            "error",
                            false,
                            "toast",
                            "x-circle"
                          );

                          setModal({});
                        });
                      break;

                    default:
                      break;
                  }
                }}
              >
                {({
                  errors,
                  touched,
                  handleSubmit,
                  handleChange,
                  handleBlur,
                  submitForm,
                }) => (
                  <Fragment>
                    <Form className={styles.form} onSubmit={handleSubmit}>
                      <div
                        className={styles.fieldRow}
                        style={{ paddingBottom: 0 }}
                      >
                        <FieldInput
                          id="alert"
                          type="select"
                          label="Alert"
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          required
                          options={options}
                          showErrors
                          errors={errors.alert}
                          touched={touched.alert}
                        />
                      </div>
                      <div className={styles.fieldRow}>
                        <FieldInput
                          id="notes"
                          type="text"
                          label="Notes"
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          required
                          showErrors
                          errors={errors.notes}
                          touched={touched.notes}
                        />
                      </div>
                    </Form>
                    <div
                      className={styles.footer}
                      style={{ justifyContent: "flex-end" }}
                    >
                      <div className={styles.buttons}>
                        <button
                          className={styles.cancel}
                          onClick={() => setModal("")}
                        >
                          Cancel
                        </button>
                        <button className={styles.save} onClick={submitForm}>
                          {loading ? (
                            <img
                              src={Loader}
                              alt="Loader"
                              className={styles.loader}
                            />
                          ) : modal.mode === "edit" ? (
                            "Update"
                          ) : (
                            "Create"
                          )}
                        </button>
                      </div>
                    </div>
                  </Fragment>
                )}
              </Formik>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
}
